<template>
  <div class="ml-3">
    <el-form
      ref="form"
      :rules="rules"
      :model="search"
    >
      <h2>Global Search</h2>
      <el-form-item
        label="Show Preview"
        prop="isShowPeek"
      >
        <el-switch
          v-model="search.isShowPeek"
          active-text="Yes"
          inactive-text="No"
        />
      </el-form-item>
      <el-form-item
        label="Search"
        prop="isNewSearch"
      >
        <el-switch
          v-model="search.isNewSearch"
          active-text="Version 2"
          inactive-text="Version 1"
        />
      </el-form-item>
      <el-form-item
        label="Searchables"
        prop="searchable"
      >
        <el-checkbox-group v-model="search.searchable">
          <el-checkbox
            v-for="searchable in searchables"
            :key="searchable"
            :label="searchable"
          >
            {{ $filters.titleize(searchable) }}
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item
        label="Search Limit"
        prop="resultsPerPage"
      >
        <el-input
          v-model="search.resultsPerPage"
          size="small"
          style="width: 100px;"
          type="number"
          placeholder="30"
          min="1"
          max="50"
        />
      </el-form-item>
      <el-divider />
      <h2>Filters</h2>
      <el-form-item
        label="Advanced Filters"
        prop="isAdvancedFilter"
      >
        <el-switch
          v-model="search.isAdvancedFilter"
          active-text="Yes"
          inactive-text="No"
        />
      </el-form-item>
      <el-form-item
        label="Remember Filters"
        prop="storeFilters"
      >
        <el-switch
          v-model="search.storeFilters"
          active-text="Yes"
          inactive-text="No"
        />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    search: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      searchables: ['account', 'pickup', 'carrier', 'profile', 'consignment', 'team'],
      rules: {}
    }
  }
}
</script>
